import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetMapCangku from "@/components/AssetMapCangku";
const WarehouseView3D = ({ className = "", }) => {
    // 四角装饰样式配置
    const cornerStyles = {
        "top-left": {
            borderTop: "0.04rem solid blue",
            borderLeft: "0.04rem solid blue",
        },
        "top-right": {
            borderTop: "0.04rem solid blue",
            borderRight: "0.04rem solid blue",
        },
        "bottom-left": {
            borderBottom: "0.04rem solid blue",
            borderLeft: "0.04rem solid blue",
        },
        "bottom-right": {
            borderBottom: "0.04rem solid blue",
            borderRight: "0.04rem solid blue",
        },
    };
    return (_jsxs("div", { className: `relative 
                bg-gradient-to-br from-blue-900/10 to-slate-900/20 
                backdrop-blur-sm 
                border-[0.02rem] border-blue-600 
                h-full
                ${className}`, children: [Object.entries(cornerStyles).map(([pos, style]) => (_jsx("div", { style: style, className: `absolute 
                    ${pos.includes("top")
                    ? "top-[-0.03rem]"
                    : "bottom-[-0.03rem]"} 
                    ${pos.includes("left")
                    ? "left-[-0.03rem]"
                    : "right-[-0.03rem]"} 
                    w-[0.5rem] h-[0.5rem] 
                    ` }, pos))), _jsx("div", { className: "relative flex-1 h-full min-h-0", children: _jsx(AssetMapCangku, {}) })] }));
};
export default WarehouseView3D;
